// extracted by mini-css-extract-plugin
export default {"overlayPreview":"CustomOverlayManager_overlayPreview__Y4EVn","overlayPreviewContainer":"CustomOverlayManager_overlayPreviewContainer__vcalf"};